module.exports = new __parcel__URL__("lahaina-fire-background.e21f19be.jpg").toString();